<div [formGroup]="item" class="order-entry-container">
    <div class="order-entry-form">
        <div class="oder-entry-form-line fxlayout-row-order-item">
            <input formControlName="id" type="hidden">
            <mat-form-field class="children-equal-1">
                <mat-label>Project</mat-label>
                <input [matAutocomplete]="autoBudget" formControlName="budget" matInput type="text">
                <mat-autocomplete #autoBudget="matAutocomplete" (optionSelected)="budgetChange($event)"
                                  [displayWith]="budgetDisplayFn">
                    @for (budget of filteredBudgets | async; track budget) {
                        <mat-option [value]="budget">
                            @if (budget.project) {
                                <span>{{ budget | projectNr }}-</span>
                            }{{ budget.budgetNr }}
                            @if (budget.company && budget.company.companyName) {
                                <small>
                                    {{ budget.company.companyName }}
                                </small>
                            }
                        </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            @if (item.controls['budget'].value) {
                <a mat-icon-button matTooltip="go to the budget" [routerLink]="['/budget', item.controls['budget'].value.id]">
                    <mat-icon>link</mat-icon>
                </a>
            }
        </div>

        <div class="oder-entry-form-line fxlayout-row-order-item">
            @if (item.get('material').value?.isOnlyFinal) {
                <mat-icon style="color:#19b059"
                          title="Custom defined material">
                    new_releases
                </mat-icon>
            }

            <mat-form-field style="flex-grow:5; flex-basis: 50%;">
                <mat-label i18n>Choose Material</mat-label>
                <mat-select (selectionChange)="onMaterialSelected($event.value)" [compareWith]="compareMaterial"
                            formControlName="material">
                    @for (material of materials$ | async; track material) {
                        <mat-option [value]="material">
                            {{ material.description }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <span style="margin-left:10px; margin-right: 5px;">
            or create new material:
          </span>

            <div>
                <button [disabled]="item.disabled" (click)="addNewMaterial()" mat-mini-fab
                        style="background-color: cadetblue;"
                        title="Include new material"
                        type="button">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>


        <div class="oder-entry-form-line fxlayout-row-order-item-2">
            <mat-form-field class="mat-form-field-lg">
                <mat-label i18n>Ordered material</mat-label>
                <input [disabled]="true"
                       [value]="item.get('material').value ? item.get('material').value.description : ''"
                       class="form-control"
                       matInput
                       type="text">
            </mat-form-field>
            <mat-form-field class="mat-form-field-lg">
                <mat-label i18n>Referenced material</mat-label>
                <input [disabled]="true"
                       [value]="item.get('material').value ? getRefItemDescr(item.get('material').value.referencedMaterialId) : ''"
                       class="form-control"
                       matInput
                       type="text">
            </mat-form-field>
            <mat-form-field class="mat-form-field-sm">
                <mat-label i18n>Code</mat-label>
                <input [attr.id]="'description'+index" class="form-control" formControlName="code"
                       matInput
                       type="text">
            </mat-form-field>
            <mat-form-field class="mat-form-field-sm">
                <mat-label i18n>Unit</mat-label>
                <mat-select formControlName="unit">
                    @for (u of unities; track u) {
                        <mat-option [value]="u">
                            {{ u }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <mat-form-field class="mat-form-field-sm">
                <mat-label i18n>Quantity</mat-label>
                <input [attr.id]="'quantity'+index" class="form-control" formControlName="quantity"
                       matInput
                       type="number">
            </mat-form-field>
            <mat-form-field class="mat-form-field-sm">
                <mat-label i18n>Price per unit</mat-label>
                <input [attr.id]="'costEach'+index" class="form-control" formControlName="costEach"
                       matInput
                       type="number">
            </mat-form-field>
            <mat-form-field class="mat-form-field-sm">
                <mat-label i18n>Discount (%)</mat-label>
                <input [attr.id]="'discount'+index" class="form-control" formControlName="discount"
                       matInput
                       type="number">
            </mat-form-field>
            <div>
                <span class="entry-total-value">{{ total | currency:currency }}</span>
            </div>
        </div>


        <div class="oder-entry-form-line fxlayout-row-order-item">
            <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label i18n>Item description</mat-label>
                <textarea [attr.id]="'description'+index" class="form-control" formControlName="description"
                                  matAutosizeMaxRows="10" matAutosizeMinRows="3" matInput
                                  matTextareaAutosize></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="order-entry-remove-button">
        <div>
            <button mat-icon-button (click)="removed.emit(index)" [disabled]="atLeastOneInvoiceAssociated">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
        <div>
            @if (atLeastOneInvoiceAssociated) {
                <div>
                    At least 1 Invoice or Ddt is associated.
                </div>
            }
            @if (relativeBudgetArchived) {
                <div>
                    Relative budget is archived.
                </div>
            }
        </div>
    </div>
</div>
